<template>
  <nav class="bar bar-nav home-bar-nav" :class="navClass">
    <a class="icon pull-left open-panel" @click="onPanelClick()">
      <img
        src="https://mobile.rcclchina.com.cn/Themes/RcclMobileTheme/Images/home_iconmenu2.png"
        alt=""
        style="vertical-align: initial"
      />
      <span class="nav-title">{{ pageTitle }}</span>
    </a>
    <h3 class="title">
      <router-link to="/">
        <img
          src="https://mobile.rcclchina.com.cn/Themes/RcclMobileTheme/Images/home_logo.png"
          class="header-logo"
          alt=""
        />
      </router-link>
    </h3>

    <div class="right-icon">
      <a
        class="icon pull-right external livechat_online"
        id="livechat_online"
        @click="customerChat()"
      >
        <img
          src="https://mobile.rcclchina.com.cn/Themes/RcclMobileTheme/Images/livechat_home.png"
        />
      </a>
      <a
        class="icon external"
        @click="customerService()"
      >
        <img
          src="https://resource.rcclchina.com.cn/tui2/06--shape%402x.png"
          alt=""
        />
      </a>
      <a class="icon external faqIcon" @click="goPage('/TopFaq', 'faq')">
        <img src="https://resource.rcclchina.com.cn/tui2/faqIcon.png" alt="" />
      </a>
    </div>
  </nav>
</template>

<script>
import { gioTracking } from "@/utilities/tools";
export default {
  name: "BaseHeader",
  data() {
    return {
      navClass: {},
    };
  },
  mounted() {
    this.navClass = this.getNavClass(this.isHeaderTrans);
  },
  methods: {
    onPanelClick() {
      this.$store.dispatch("SET_NAV_PANEL", true);
    },
    getNavClass(isHeaderTrans) {
      if (isHeaderTrans) {
        return {
          trans: true,
        };
      }
      return {};
    },
		goPage(link, eventName) {
			gioTracking('track','evt_ButtonClicked', {'btnType': eventName});
			this.$router.push(link);
		},
    customerChat(){
      gioTracking('track','evt_MainMenu', {
        menu:7,
        subMenu:1,
        desUrl:'https://rcclchina.udesk.cn/im_client/?web_plugin_id=75221'
      })
      try {
        this._hmt.push(['_trackEvent', 'Customer_Service', 'Click', 'top', 1])
      } catch (error) {
        console.error(error)
      }
      window.open('https://rcclchina.udesk.cn/im_client/?web_plugin_id=75221', 'newwindow', 'height=400, width=400')
    },
    customerService(){
      gioTracking('track','evt_MainMenu', {
        menu:8,
        subMenu:1,
        desUrl:'tel:400-820-7293'
      })
      try {
        this._hmt.push(['_trackEvent', 'Call', 'Click', 'top', 1])
      } catch (error) {
        console.error(error)
      }
      window.location.href = 'tel:400-820-7293'
    }
  },
  computed: {
    pageTitle() {
      return this.$store.state.page.pageTitle || "";
    },
    isHeaderTrans() {
      return this.$store.state.page.isHeaderTrans || false;
    },
  },
  watch: {
    isHeaderTrans(newValue) {
      this.navClass = this.getNavClass(newValue);
    },
  },
};
</script>

<style scoped>
img {
  display: block;
}

nav.home-bar-nav.trans {
  background-image: linear-gradient(
    rgba(0, 0, 0, 0.3) 0%,
    rgba(0, 0, 0, 0.1) 100%
  );
}
</style>
